<ng-content></ng-content>

@if (showAnimation) {
  <svc-reaction-animation
    @fadeOut
    [reactionAnimation]="currentCustomReactionAnimation"
    [relativeFromElement]="relativeFromElement"
  />
}

<ng-template #reactionsTemplate>
  <div [hidden]="disabled" class="svc-reaction-list-wrapper">
    <section class="shadow bg-white">
      <div class="flex" [style.width.px]="reactionsType.length * 30">
        @for (reactionType of reactionsType; track reactionType.reactionUniqueId) {
          <div
            class="svc-reaction-item"
            [ngClass]="{ 'active': reactionType.reactionUniqueId == currentReactionType?.reactionUniqueId }"
            (click)="makeReactionByClick(reactionType)"
          >
            <img [src]="reactionType.staticImageUrl" />
            <img [src]="reactionType.animatedImageUrl" />
          </div>
        }
      </div>
      @if (loadingList || loadingCurrent) {
        <div class="flex justify-center items-center svc-reaction-loading">
          <mat-spinner diameter="20"></mat-spinner>
        </div>
      }
      @if (loadingList && !loadingCurrent) {
        <div class="flex" [style.width.px]="5 * 30">
          @for (_ of [1,2,3,4,5]; track _) {
            <div class="svc-reaction-item cursor-default hover:bg-transparent">
              <ngx-skeleton-loader [theme]="{ width: '100%', height: '100%', margin: '0' }" appearance="circle" />
            </div>
          }
        </div>
      }
    </section>
  </div>
</ng-template>
